import { apiWrapper } from 'ccs-ui-components';
import { useState } from 'react';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IServiceResponseModel } from '../../../models';
import { serviceListResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';

const useServiceEventAssociation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  async function callServiceEventAssociation(queryParams: { [key: string]: string }, eventName: string, eventVersion: string) {
    setIsLoading(true);
    const resp = await apiWrapper.post<IServiceResponseModel, { errorMessage: string }>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/services/search?page=${queryParams.page}&size=${queryParams.item}&sort=${queryParams.sort},${queryParams.type}`,
      {
        services: queryParams.serviceName ? [{ serviceName: queryParams.serviceName }] : undefined,
        status: queryParams.status ? queryParams.status.split(',') : undefined,
        associatedEvents: {
          associationType: queryParams.eventType,
          events: [{
            eventName,
            eventVersion
          }]
        },
        exactNameMatch: false

      },
      headersInstance()
    );

    const apiResponse = serviceListResponseSchema.validate(resp?.responseBody, {
      abortEarly: true
    });

    if (resp.isError || !apiResponse?.value) {
      setIsLoading(false);
      setErrorMessage(resp?.errorBody?.errorMessage || '');
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: resp.isError,
        statusCode: resp.statusCode
      };
    }
    const serviceAssociationRecords = resp?.responseBody;
    setIsLoading(false);

    return {
      serviceAssociationRecords,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }

  const serviceEventAssociation = async (queryParam: { [key: string]: string }, eventName: string, eventVersion: string) => callServiceEventAssociation(queryParam, eventName, eventVersion);

  return { serviceEventAssociation, isLoading, errorMessage };
};

export default useServiceEventAssociation;
